import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  author = 'Minerva Education AI', 
  ogType = 'website',
  ogImage = '/logo/logo.png',
  ogUrl,
  canonical
}) => {
  // Costruisci il titolo completo (con suffisso)
  const fullTitle = title 
    ? `${title} | Minerva Education AI` 
    : 'Minerva Education AI | Intelligenza artificiale per l\'istruzione';

  return (
    <Helmet>
      {/* Titolo e meta tag di base */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      
      {/* Meta tag per Open Graph (Facebook, LinkedIn) */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      <meta property="og:site_name" content="Minerva Education AI" />
      
      {/* Meta tag per Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* URL canonico */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Meta tag per la lingua */}
      <meta property="og:locale" content="it_IT" />
      <meta httpEquiv="content-language" content="it-IT" />
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  keywords: PropTypes.string,
  author: PropTypes.string,
  ogType: PropTypes.string,
  ogImage: PropTypes.string,
  ogUrl: PropTypes.string,
  canonical: PropTypes.string
};

export default SEO; 